import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import {
  FALLBACK_LOCALE,
  SUPPORTED_LOCALES,
  defaultNS,
  resources,
} from "./resources.ts";

/** Matches the app's other localStorage keys (`maestro-access-token`, ...). */
export const LOCALE_STORAGE_KEY = "maestro-locale";

const supportedLngs = SUPPORTED_LOCALES.map((locale) => locale.code);

/**
 * A browser set to Brazilian Portuguese may report `pt`, `pt-br` or `pt-PT`.
 * Without this, every one of them misses `pt-BR` and silently falls back to
 * English.
 */
export const convertDetectedLanguage = (lng: string): string =>
  lng.toLowerCase().startsWith("pt") ? "pt-BR" : lng;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    fallbackLng: FALLBACK_LOCALE,
    supportedLngs,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      convertDetectedLanguage,
    },
    interpolation: {
      // React already escapes interpolated values.
      escapeValue: false,
    },
    react: {
      // Resources are bundled and registered synchronously above, so there is
      // nothing to suspend on — and the app has no i18n suspense boundary.
      useSuspense: false,
    },
  });

export default i18n;
